import { render, staticRenderFns } from "./CustomerCampaignReceiptSendMessage.vue?vue&type=template&id=f247ad3c&scoped=true"
import script from "./CustomerCampaignReceiptSendMessage.vue?vue&type=script&lang=js"
export * from "./CustomerCampaignReceiptSendMessage.vue?vue&type=script&lang=js"
import style0 from "./CustomerCampaignReceiptSendMessage.vue?vue&type=style&index=0&id=f247ad3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f247ad3c",
  null
  
)

export default component.exports